// src/index.ts
function createThunkMiddleware(extraArgument) {
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === "function") {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware();
var withExtraArgument = createThunkMiddleware;
export { thunk, withExtraArgument };